import { useCallback, useMemo } from 'react';
import { useAuth } from '@clerk/nextjs';

export function useClerkAuth() {
  const {
    isSignedIn,
    userId,
    sessionId,
    getToken: getClerkToken,
    isLoaded,
    signOut,
  } = useAuth();

  const data = useMemo(
    () => ({
      clerkLoaded: isLoaded,
      clerkUserId: isSignedIn ? userId : null,
      clerkSessionId: isSignedIn ? sessionId : null,
    }),
    [isLoaded, isSignedIn, sessionId, userId],
  );

  const isReady =
    data.clerkLoaded &&
    typeof data.clerkUserId !== 'undefined' &&
    typeof data.clerkSessionId !== 'undefined';

  const getToken = useCallback(async () => {
    if (isSignedIn) {
      return await getClerkToken();
    }

    return null;
  }, [getClerkToken, isSignedIn]);

  return {
    data,
    isReady,
    isSignedIn,
    getToken,
    signOut,
  };
}
